module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"informationBar":{"announcement":"Announcement","downtime":"Maintenance"}},"de":{"informationBar":{"announcement":"Ankündigung","downtime":"Wartung"}},"fr":{"informationBar":{"announcement":"Annonce","downtime":"Maintenance"}},"it":{"informationBar":{"announcement":"Annuncio","downtime":"Manutenzione"}}}')
  delete Component.options._Ctor
}
